export function getUrl(medium: string) {
  return `https://pro.chakra-ui.com/components?utm_source=chakra-ui.com&utm_medium=${medium}`
}
